export default __webpack_public_path__ + "static/drop-a-line-ddc5a52c7a806e176cf2e32736ea9cc1.svg";